module.exports = __webpack_public_path__ + "static/media/serving-masonry.0f352d79.png";